var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuided(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L17 0 17 17 0 17z",
    transform: "translate(-1108 -469) translate(1096 445) translate(12 24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E71",
    fillRule: "nonzero",
    d: "M4.951 7.792l-2.826 2.833 2.826 2.833v-2.125h4.966V9.917H4.95V7.792zm9.924-1.417l-2.826-2.833v2.125H7.083v1.416h4.966v2.125l2.826-2.833z",
    transform: "translate(-1108 -469) translate(1096 445) translate(12 24)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuided);
export default __webpack_public_path__ + "static/media/guided.650a355ec1575c7ab7095119b7f22dcf.svg";
export { ForwardRef as ReactComponent };